
import { Component, Vue } from 'vue-property-decorator'
import {
  GetRoleList,
  AllMenu,
  SaveRole,
  GetRoleInfo,
  GetRoleButton,
  SaveRoleButton,
  DelButton,
  SaveButton,
  DelRole,
  GetUserMenu,
  GetRoleTypeList
} from '@/api/admin/permission'
@Component
export default class adminRole extends Vue {
  name = 'userAdmin_adminRole'
  select = {
    role_type_list: []
  }
  table = {
    type: 1000000,
    data: [],
    column: [
      // 列表
      { title: 'ID', key: 'role_id', align: 'center', width: 50 },
      {
        title: '角色分类',
        key: 'role_type',
        align: 'center',
        width: 80,
        render: (h, params) => {
          let item: any = this.select.role_type_list.find(
            (el: any) => el.id == params.row.role_type
          )
          let str = item ? item.name : ''
          return h('span', str)
        }
      },
      { title: '角色名称', key: 'name', align: 'center', width: 80 },
      { title: '描述', key: 'description', align: 'center', minWidth: 100 },
      { title: '角色等级', key: 'sort', align: 'center', width: 70 },
      {
        title: '状态',
        key: 'status',
        align: 'center',
        width: 100,
        render: (h, params) => {
          return h(
            'div',
            {
              style: {
                color: `${['#19be6b', '#ed4014'][params.row.status - 1]}`
              }
            },
            ['启用', '禁用'][params.row.status - 1]
          )
        }
      },
      {
        title: '编辑角色',
        key: 'operate',
        align: 'center',
        minWidth: 110,
        render: (h, params) => {
          return h('div', [
            h(
              'Button',
              {
                props: { type: 'primary', size: 'small' },
                on: {
                  click: () => {
                    this.table.form.params = {
                      ...params.row
                    }
                    if (!this.table.form.params.role_type) {
                      let initRole: any = this.select.role_type_list[0]
                      if (initRole) {
                        this.table.form.params.role_type = initRole.id
                      }
                    }
                    this.table.form.show = true
                  }
                }
              },
              '编辑'
            ),
            h(
              'Button',
              {
                props: { type: 'error', size: 'small' },
                style: { margin: '2px' },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '确认删除',
                      content: '<p>角色下有管理员 会删除失败</p>',
                      onOk: () => {
                        this.delRole(params.row.role_id)
                      }
                    })
                  }
                }
              },
              '删除'
            )
          ])
        }
      },
      {
        title: '编辑权限',
        key: 'operate',
        align: 'center',
        width: 100,
        render: (h, params) => {
          let bol = false
          return h('div', [
            h(
              'Button',
              {
                props: {
                  type: this.table.type == params.index ? 'warning' : 'success',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.Button.role_id = params.row.role_id
                    this.Tree.name = params.row.name
                    this.table.type = params.index
                    this.table.form.setParams = {
                      ...params.row
                    }
                    this.getRoleInfo(params.row.role_id)
                  }
                }
              },
              '编辑'
            )
          ])
        }
      }
    ],
    form: {
      show: false,
      ref: 'setRole',
      params: {
        role_id: 0,
        role_type: 0,
        status: 1,
        menus: [],
        buttons: [],
        sort: 0,
        name: '',
        description: ''
      },
      setParams: {
        role_id: 0,
        status: 1,
        menus: [],
        buttons: [],
        sort: 0,
        name: '',
        description: ''
      },
      rule: {
        role_type: [
          {
            required: true,
            trigger: 'change',
            validator: (this as any).simpleVerify('请选择角色分类')
          }
        ],
        name: [{ required: true, message: '请填写角色名称', trigger: 'blur' }],
        description: [
          { required: true, message: '请填写角色描述', trigger: 'blur' }
        ],
        sort: [
          {
            required: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
              let val = value || []
              if (val.length < 0) {
                callback('角色等级必须大于0')
              } else {
                callback()
              }
            }
          }
        ]
      }
    }
  }
  Tree = { name: '', btn_name: '', data: [], tree_data: [], menus: [] }
  Button = {
    isPage: false,
    role_id: 0,
    menu_id: 0,
    form: {
      show: false,
      ref: 'btnForm',
      params: { desc: '', button: '', func: '', button_id: 0 },
      rule: {
        desc: [
          { required: true, message: '请填写按钮功能名称', trigger: 'blur' }
        ],
        button: [
          { required: true, message: '请填写按钮对应标识', trigger: 'blur' }
        ],
        func: [
          { required: true, message: '请填写按钮调用方法', trigger: 'blur' }
        ]
      }
    },
    table: {
      data: [],
      columns: [
        { type: 'selection', align: 'center', width: 30 },
        { title: 'id', key: 'button_id', align: 'center' },
        { title: '标识', key: 'button', align: 'center' },
        { title: '名称', key: 'desc', align: 'center' },
        { title: '调用方法', key: 'func', align: 'center' },
        {
          key: 'pack_no',
          title: '操作状态',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    margin: '2px'
                  },
                  on: {
                    click: () => {
                      this.btnShow()
                      this.Button.form.params.desc = params.row.desc
                      this.Button.form.params.button = params.row.button
                      this.Button.form.params.func = params.row.func
                      this.Button.form.params.button_id = params.row.button_id
                    }
                  }
                },
                '编辑'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  style: {
                    margin: '2px'
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '确认删除',
                        content: '<p>是否确认删除此按钮</p>',
                        onOk: () => {
                          this.delButton(params.row.button_id)
                        }
                      })
                    }
                  }
                },
                '删除'
              )
            ])
          }
        }
      ]
    }
  }
  //获取列表
  getRoleList() {
    GetRoleList({}).then(res => {
      this.table.data = res['_param'].list
    })
  }
  //新增角色
  Reset() {
    this.table.form.params.role_id = 0
    ;(this.$refs[this.table.form.ref] as any).resetFields()
    let initRole: any = this.select.role_type_list[0]
    if (initRole) {
      this.table.form.params.role_type = initRole.id
    }
    this.table.form.show = true
  }
  closeReset() {
    ;(this.$refs[this.table.form.ref] as any).resetFields()
    this.table.form.show = false
  }
  //提交角色配置
  updatedSaveRole() {
    ;(this.$refs[this.table.form.ref] as any).validate(valid => {
      if (valid) {
        this.saveRole()
      }
    })
  }
  saveRole(type?) {
    let params: any = {}
    if (type) {
      let menus: any = []
      let data: any = this.Tree.data || []
      data.map(item => {
        if (item.checked || item.indeterminate) {
          menus.push(item.menu_id)
        }
        item['children'].map(item1 => {
          if (item1.checked || item1.indeterminate) {
            menus.push(item1.menu_id)
          }
          item1['children'].map(item2 => {
            if (item2.checked || item2.indeterminate) {
              menus.push(item2.menu_id)
            }
          })
        })
      })
      this.table.form.setParams.menus = menus
      params = { ...this.table.form.setParams }
    } else {
      params = { ...this.table.form.params }
    }
    SaveRole(params).then(res => {
      this.$Message.success('提交成功')
      setTimeout(() => {
        this.getRoleList()
      }, 1000)
      this.closeReset()
    })
  }
  //删除角色
  delRole(id) {
    let param = {
      role_id: id
    }
    DelRole(param).then(res => {
      setTimeout(() => {
        this.getRoleList()
      }, 1000)
      this.$Message.success('删除成功')
    })
  }
  //获取所有菜单
  allMenu() {
    GetUserMenu({}).then(res => {
      let dataList = res['_param'].list || []
      let data = dataList
      let arr: any = []
      let arrList: any = []
      data.map(item => {
        item.children = item.children || []
        item.children.sort((v1, v2) => {
          return v1.sorts - v2.sorts
        })
        item.children.map(item2 => {
          item2.children = item2.children || []
          item.expand = true
          item2.children.map(item3 => {
            item3.expand = true
            item3.children = item3.children || []
          })
        })
      })
      data = (this as any).copyData(dataList || [])
      let tree_data = (this as any).copyData(dataList || [])
      // 树层级内容
      //   let tree_data = [
      //     {
      //       title: "调度平台",
      //       expand: true,
      //       checked: false,
      //       disabled: false,
      //       children: (this as any).copyData(dataList || [])
      //     }
      //   ];
      tree_data[0].children.map(item => {
        item.expand = true
        item.children = item.children.filter(v => v)
      })
      this.Tree.data = (this as any).copyData(tree_data)
      this.Tree.tree_data = (this as any).copyData(tree_data)
    })
  }
  //取消配置页面权限
  closeRoleMenu() {
    this.table.type = 999
    this.getRoleList()
    this.allMenu()
  }
  //获取某个角色
  getRoleInfo(id) {
    let param = { role_id: id }
    GetRoleInfo(param).then(res => {
      this.table.form.setParams = res['_param']
      let menu_ids = res['_param'].menus
      let data: any = (this as any).copyData(this.Tree.tree_data)
      data[0].children.map(item => {
        if (menu_ids.includes(item.menu_id)) {
          item.checked = true
          item.expand = true
        } else {
          item.checked = false
        }
        item['children'].map(item1 => {
          if (menu_ids.includes(item1.menu_id)) {
            item1.checked = true
            item1.expand = true
          } else {
            item.checked = false
          }
          item1['children'].map(item2 => {
            if (menu_ids.includes(item2.menu_id)) {
              item2.checked = true
              item2.expand = true
            } else {
              item.checked = false
            }
          })
        })
      })
      this.Tree.data = (this as any).copyData(data)
    })
  }
  //获取页面按钮
  getRoleButton() {
    let params = { menu_id: this.Button.menu_id, role_id: this.Button.role_id }
    GetRoleButton(params).then(res => {
      let data = res['_param'].button || []
      data.forEach(item => {
        item._checked = item.status == 1
      })
      this.Button.table.data = data
    })
  }
  //添加按钮
  saveButton() {
    ;(this.$refs[this.Button.form.ref] as any).validate(valid => {
      if (valid) {
        let param = { ...this.Button.form.params }
        param['menu_id'] = this.Button.menu_id
        SaveButton(param).then(res => {
          this.$Message.success('配置成功')
          this.Button.form.show = false
          this.getRoleButton()
        })
      }
    })
  }
  //编辑按钮权限
  btnChange(data) {
    if (!this.Button.role_id) return this.$Message.error('请选择角色信息')
    if (data.length) {
      if (data[0].ispage == 2) {
        this.Button.isPage = true
      } else {
        this.Button.isPage = false
        return false
      }
      this.Button.menu_id = data[0].menu_id
      this.getRoleButton()
      this.Tree.btn_name = data[0].title
    }
  }
  //删除按钮
  delButton(id) {
    let params = {
      button_id: id
    }
    DelButton(params).then(res => {
      this.getRoleButton()
      this.$Message.success('删除成功')
    })
  }
  //保存按钮权限
  saveRoleButton() {
    let data = (this as any).copyData(this.Button.table.data)
    let arr: any = []
    data.map(item => {
      if (item._checked) {
        arr.push(item.button_id)
      }
    })
    let param = {
      menu_id: this.Button.menu_id,
      role_id: this.Button.role_id,
      buttons: arr
    }
    SaveRoleButton(param).then(Res => {
      this.getRoleButton()
      this.$Message.success('保存成功')
    })
  }
  btn_Change(data) {
    let arr: any = []
    data.map(item => {
      arr.push(item.button_id)
    })
    this.Button.table.data.map((item: any) => {
      if (arr.includes(item.button_id)) {
        item._checked = true
      } else {
        item._checked = false
      }
    })
  }
  btnShow() {
    ;(this.$refs[this.Button.form.ref] as any).resetFields()
    this.Button.form.show = true
    this.Button.form.params.button_id = 0
  }
  GetRoleTypeList() {
    GetRoleTypeList({}).then(res => {
      this.select.role_type_list = res._param.list || []
    })
  }
  created() {
    this.GetRoleTypeList()
  }

  mounted() {
    this.getRoleList()
    this.allMenu()
  }
}
